import { undashifyAndCapitalise } from "@cinch-labs/shared-util";
import { getStoryBySlug } from "@cinch-nx/data-storyblok";
import { tagError, setTag, traceFunction } from "@core/datadog-server";
const instrumentedGetStoryBySlug = traceFunction("getStoryBySlug", getStoryBySlug);
export const getStaticPropsGenerator = ({ path , resolveRelations , passedBreadCrumbs , shouldUndashifyAndCapitalise  })=>{
    return async ({ params , preview =false  })=>{
        const slug = params === null || params === void 0 ? void 0 : params.slug;
        try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const story = await instrumentedGetStoryBySlug(`${path}/${slug}`, {
                version: preview ? "draft" : "published",
                resolve_relations: resolveRelations
            });
            const breadCrumbs = [
                ...passedBreadCrumbs,
                shouldUndashifyAndCapitalise && {
                    text: undashifyAndCapitalise(slug),
                    url: `/${path}/${slug}`
                }
            ];
            return {
                props: {
                    story,
                    preview,
                    layoutProps: {
                        showBorderRadius: true,
                        breadCrumbs
                    }
                },
                revalidate: 60
            };
        } catch (error) {
            if (typeof error === "string" || error instanceof Error) {
                tagError(error);
            }
            setTag("response.statusCode", 404);
            console.log(error);
            return {
                notFound: true,
                props: {
                    story: null,
                    preview,
                    layoutProps: {
                        showBorderRadius: true,
                        breadCrumbs: []
                    }
                },
                revalidate: 60
            };
        }
    };
};
